import { Component, OnInit,  EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-dashboard-preview',
  templateUrl: './dashboard-preview.component.html',
  styleUrls: ['./dashboard-preview.component.scss']
})
export class DashboardPreviewComponent implements OnInit {
  @Input() position: string;
  @Input() fade_das: boolean;
  @Output() dash_state = new EventEmitter();

  constructor() {
  }

  ngOnInit() {
  }

  fade_out(value) {
    this.dash_state.emit(value);
  }

}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/shared/dashboard-preview/dashboard-preview.component.ts